import React, { useRef, useState } from 'react';
import { connect } from 'react-redux';
import styled, { css } from 'styled-components';

const ErrorTooltipWrapper = styled.div` 
  ${(props) => {
    const { inline, topOffset = 0 } = props;
    const ebc = '#CC0000';
    const ec = '#FFFFFF';

  return css`
      && {
        ${inline &&
          'display: inline-block; margin-left: 10px;'
        }
        
        .help-icon {
          position: ${inline ? 'unset' : 'absolute'};
          z-index: 1;
          right: 13px;
          top: ${`${(10 + topOffset)}px`};
          i {
            color: ${ebc}
          }
        }

        .error-tooltip-trigger {
          padding: 0;
          border: 0;
          background: transparent;
          cursor: pointer;
        }

        .error-tooltip-trigger:focus-visible {
          outline: 2px solid #212529;
          outline-offset: 2px;
          border-radius: 2px;
        }
      
        .help-info {
          margin: 5px;
          padding: 10px;
          border-radius: 6px;
          background: ${ebc};
          color: ${ec};
          position: absolute;
          top: ${`${(-40 + topOffset)}px`};
          max-width: 500px;
          height: max-content;
          right: 0;
          z-index: 100;
          box-shadow: 0px 0px 3px 0px rgba(0, 0, 0, 0.5);
        }

        .help-info.dismissible {
          padding-right: 32px;
        }

        .close-error-tooltip {
          position: absolute;
          top: 4px;
          right: 6px;
          padding: 0;
          border: 0;
          background: transparent;
          color: ${ec};
          font-size: 20px;
          line-height: 1;
          cursor: pointer;
        }

        .close-error-tooltip:focus-visible {
          outline: 2px solid ${ec};
          outline-offset: -2px;
          border-radius: 2px;
        }

        .close-error-tooltip::before {
          content: '×';
        }
        
        .help-info:before {
          content: ' ';
          height: 0;
          position: absolute;
          width: 0;
          right: 4px;
          top: 35px;
          border: 10px solid transparent;
          border-top-color: ${ebc};
        }
      }`
  }}
`;

export const errorFieldClass = (errors, field) => {
  let classStyle = '';
  let message = '';

  const error = errors.find(e => e.key === field && !e.fieldChanged);
  if (error) {
    classStyle = 'error';
    message = error.value.split(': ').pop();
  }

  return { classStyle, message }
}

export const ErrorTooltip = (props) => {
  const { inline, message, styles, topOffset } = props;
  const [isOpen, setIsOpen] = useState(true);
  const triggerRef = useRef(null);

  const closeTooltip = () => {
    triggerRef.current?.focus();
    setIsOpen(false);
  };

  return (
    <ErrorTooltipWrapper className='error-tooltip' topOffset={topOffset} inline={inline} styles={styles}>
      <div className='help-icon'>
        <button
          ref={triggerRef}
          type="button"
          className="error-tooltip-trigger"
          aria-label="Show error message"
          aria-expanded={isOpen}
          onClick={() => setIsOpen(true)}
        >
          <i className="fa fa-exclamation-circle" />
        </button>
      </div>

      {isOpen && (
        <div className="card help-info dismissible">
          <div className="card-body">
            {message}
          </div>
          <button
            type="button"
            className="close-error-tooltip"
            aria-label="Close error message"
            onClick={closeTooltip}
          />
        </div>
      )}
    </ErrorTooltipWrapper>
  )
}

export default connect(
  ({ settings: { style = {} } }) => ({
    styles: style,
  })
)(ErrorTooltip);
